'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MONTHLY = exports.MONTHLY = 'monthly';
var ANNUAL = exports.ANNUAL = 'annual';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/Terms.js
// module id = 28
// module chunks = 3 4 5